module.exports = __webpack_public_path__ + "static/Publix_pin_hover-278d87c9feabda55352cfd90f256785e.png";